// React 19 compat shims for legacy antd v4 / rc-* internals — must load
// before any antd render. See @impero-com/ui/src/polyfills/reactDom19Compat.ts.
import "@impero-com/ui/reactDom19Compat";
import "@impero-com/common/utils/initialize-zod";
import "./utils/initialize-moment-locales";
import "react-loading-skeleton/dist/skeleton.css";
import "main.css";

import { Suspense } from "react";

import { QueryClientProvider } from "@impero-com/common/components/queryClient";
import { initializeSentry } from "@impero-com/common/utils/sentry";
import { PageSpinner } from "@impero-com/ui";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppSwitcher } from "./app/switcher";
import { ErrorBoundary } from "./components/errorBoundary";
import { GitInfoWatermark } from "./components/gitInfoWatermark/GitInfoWatermark";
import { setGitMetaTag } from "./utils/setGitMetaTag";

const App = () => {
    return (
        <>
            <GitInfoWatermark />
            <ErrorBoundary routeKey="app">
                <BrowserRouter>
                    <QueryClientProvider>
                        <Suspense fallback={<PageSpinner />}>
                            <AppSwitcher />
                        </Suspense>
                    </QueryClientProvider>
                </BrowserRouter>
            </ErrorBoundary>
        </>
    );
};

initializeSentry("v2");
setGitMetaTag();
const container = document.getElementById("app");
const root = createRoot(container!);
root.render(<App />);
